import { secureGet } from '../utils/HttpUtils';

export type TenantUiScope = 'risk.summary' | 'risk.indicators';

export type RiskSummaryUiSettings = {
  layoutVariant?: string;
  sectionOrder?: string[];
  companyHeader?: {
    showCompanyName?: boolean;
    showActivity?: boolean;
    showReferrer?: boolean;
  };
  nosisScores?: { codes?: string[] };
  nosisRejectedChecks?: { enabled?: boolean };
  motivo?: { editable?: boolean };
};

export type RiskIndicatorsUiSettings = {
  columns?: 1 | 2;
  groupOrder?: string[];
  groupTitles?: Record<string, string>;
};

export type TenantUiSettingsResponse = {
  settings: Record<string, unknown> | null;
};

const apiUrls = {
  ui: '/v1/private/ui/',
};

/**
 * GET /v1/private/ui/{scope}. BFF returns `{ settings: null }` when tenant has no row (legacy UI).
 */
export async function getTenantUiSettings(
  scope: TenantUiScope
): Promise<TenantUiSettingsResponse> {
  const response = await secureGet(apiUrls.ui + scope);
  if (!response?.success) {
    return { settings: null };
  }
  const data = response.data as TenantUiSettingsResponse | undefined;
  if (!data || data.settings == null) {
    return { settings: null };
  }
  return { settings: data.settings };
}
